import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeCalendarAdminOption } from 'src/types/shared/User';

export const fetchChallengeCalendarAdminOptionsRequest = createAction(
    'fetchChallengeCalendarAdminOptionsRequest',
);
export const fetchChallengeCalendarAdminOptionsSuccess = createAction<ChallengeCalendarAdminOptionsPayload>(
    'fetchChallengeCalendarAdminOptionsSuccess',
);
export const fetchChallengeCalendarAdminOptionsFailure = createAction(
    'fetchChallengeCalendarAdminOptionsFailure',
);

export const fetchChallengeCalendarAdminOptions = (challengeGroupID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeCalendarAdminOptionsRequest());
    try {
        const { data } = await api.get<ChallengeCalendarAdminOptionsPayload>(
            `admin/challenges/calendar-admin-options?challengeGroupID=${challengeGroupID}`,
        );
        dispatch(fetchChallengeCalendarAdminOptionsSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, fetchChallengeCalendarAdminOptionsFailure, e);
    }
};

export interface ChallengeCalendarAdminOptionsPayload {
    workshopAdmins: ChallengeCalendarAdminOption[];
    assessors: ChallengeCalendarAdminOption[];
    pitchPresentationAdmins: ChallengeCalendarAdminOption[];
}
